module.exports = __webpack_public_path__ + "img/2.65ec0075.jpg";